export { default as IndexedDB } from './indexed-db.js';
export { default as LocalStorage } from './local-storage.js';
